/**
 * Every authentication call the apps make, in one place.
 *
 * The three apps have different screens but the same protocol; keeping the
 * calls here means a change to the contract is made once.
 */
export function createAuthApi(client) {
    return {
        requestOtp: async (phone) => (await client.post('/auth/otp/request', { phone })).data,
        verifyOtp: async (input) => (await client.post('/auth/otp/verify', input)).data,
        me: async () => (await client.get('/auth/me')).data,
        saveProfile: async (input) => (await client.post('/auth/profile', input)).data,
        logout: async () => {
            await client.post('/auth/logout');
        },
        listSessions: async () => (await client.get('/auth/sessions')).data,
        revokeSession: async (sessionId) => {
            await client.delete(`/auth/sessions/${sessionId}`);
        },
        revokeOtherSessions: async () => (await client.post('/auth/sessions/revoke-all')).data,
        adminLogin: async (email, password) => (await client.post('/auth/admin/login', { email, password })).data,
        adminBeginEnrolment: async (challengeId) => (await client.post('/auth/admin/2fa/enrol', { challengeId })).data,
        adminVerifyTwoFactor: async (challengeId, code) => (await client.post('/auth/admin/2fa/verify', { challengeId, code })).data,
    };
}
//# sourceMappingURL=api.js.map